<template>
  <div class="document-box" >
    <div class="search-box">
      <div class="search-item col1-3">
        <div class="search-label longlabel">
          标题
        </div>
        <el-input v-model="param.title" maxlength="50" class="search-input" />
      </div>
      <div class="search-item col1-3">
        <div class="search-label longlabel">
          案号
        </div>
        <el-input v-model="param.caseNo" maxlength="50" class="search-input" />
      </div>
      <div class="search-item col1-3">
        <div class="search-label">
          被申请人
        </div>
        <el-input v-model="param.respondentName" maxlength="50" class="search-input" />
      </div>
      <div class="search-item col1-3">
        <div class="search-label">
          复议结论
        </div>
        <el-input v-model="param.conclusion" maxlength="50" class="search-input" />
      </div>
      <div class="search-item col1-3">
        <div class="search-label longlabel">
          行政管理类别
        </div>
        <el-input v-model="param.administrativeType" maxlength="50" class="search-input" />
      </div>
      <div class="search-item search-btns col1-4">
        <div @click="search" class="search-btn primary-btn-small">
          查询
        </div>
        <div @click="reset" class="search-btn primary-btn-small-plain">
          重置
        </div>
      </div>
    </div>
    <div class="tableBox" >
      <el-table
         :data="tableData"
         style="width: 100%"
         v-loading="loading"
          height="100%"
         header-row-class-name="header-row"
         header-cell-class-name="header-cell"
         :row-class-name="tableRowClassName">
        <el-table-column
          prop="title"
          label="标题"
          align="center"
          show-overflow-tooltip
          >
          <template slot-scope="scope">
            <span @click="previewDocuments(scope.row)" class="blue-text-btn"> {{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="caseNo"
          label="案号"
          align="center"
          show-overflow-tooltip
          >
        </el-table-column>
        <el-table-column
          prop="respondentName"
          label="被申请人"
          align="center"
          show-overflow-tooltip
          >
        </el-table-column>
         <el-table-column
          prop="administrativeType"
          label="行政管理类别"
          align="center"
          show-overflow-tooltip
          >
        </el-table-column>
        <el-table-column
          prop="conclusion"
          label="复议结论"
          align="center"
          show-overflow-tooltip
          >
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-box">
      <pagination :total="total" :page="page" :pageSize="pageSize" @loadTablelist="loadTablelist" />
    </div>
  </div>
</template>

<script>
import Api from '@api/api'
import pagination from '@/components/pagination/pagination.vue'
export default {
  components: { pagination },
  data () {
    return {
      total: null,
      page: 1,
      pageSize: 10,
      loading: false,
      tableData: [],
      param: {
        title: '',
        caseNo: '',
        respondentName: '',
        conclusion: '',
        administrativeType: ''
      }
    }
  },
  // watch: {
  //   'param.concludeTime': {
  //     handler: function (newVal) {
  //       this.param.concludeTimeStart = newVal && newVal[0] ? this.$moment(newVal[0]).format('yyyy-MM-DD') + ' 00:00:00' : ''
  //       this.param.concludeTimeEnd = newVal && newVal[1] ? this.$moment(newVal[1]).format('yyyy-MM-DD') + ' 23:59:59' : ''
  //     },
  //     deep: true
  //   }
  // },
  created () {
    this.getDocList()
  },
  methods: {
    // 列表颜色
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return 'warning-row'
      }
      return ''
    },
    filingTimeFormatter (row) {
      if (row.concludeTime) {
        return this.$moment(row.concludeTime).format('YYYY-MM-DD')
      }
    },
    // 分页
    loadTablelist (page) {
      this.page = page
      this.getDocList()
    },
    // 获取列表
    getDocList () {
      this.loading = true
      const p = {
        currentPage: this.page,
        pageSize: this.pageSize,
        ...this.param
      }
      Api.getList(p).then(res => {
        this.tableData = res.data.data.list
        this.total = res.data.data.total
        this.loading = false
      })
    },
    // 进入详情
    previewDocuments (item) {
      this.$router.push({
        name: 'DocumentsDetail',
        query: {
          item: JSON.stringify(item)
        }
      })
    },
    // 搜索
    search () {
      this.page = 1
      this.pageSize = 10
      this.getDocList()
    },
    // 重置
    reset () {
      this.param = {
        title: '',
        caseNo: '',
        respondentName: '',
        conclusion: '',
        administrativeType: ''
      }
      this.getDocList()
    }
  }
}
</script>
<style>
    .el-table .warning-row {
     background: rgba(15, 79, 171, 0.06);
    }
</style>
<style lang="scss" scoped>
  .document-box{
    height: 100%;
    overflow-y: hidden;
  }
  .search-item{
    margin: 5px 0;
  }
 ::v-deep .tableBox{
   margin-bottom: 20px;
   height: calc(100% - 150px);
   border-bottom: 1px solid #F5F7FA;
  .header-cell {
     background: rgba(15, 79, 171, 0.15);
  }
  .header-row{
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei ,sans-serif;
    font-weight: bold;
    color: #4B4B4B;
  }
  .blue-text-btn{
    color: #5A89FD;
    cursor: pointer;
    text-decoration: underline;
  }
  .el-table::before{
    background-color: transparent;
  }
}
.pagination-box{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
